<template>
	<div>
		<div class="d-flex justify-space-between align-center">
			<v-tabs v-model="tabs">
				<v-tab
					:to="{
						name: 'personal-info',
						query: { employeeId: $route.query.employeeId },
					}">
					{{ $T('tabs.personal') }}
					<v-avatar
						v-if="personalValidation"
						size="25"
						color="error white--text">
						{{ personalValidation }}
					</v-avatar>
				</v-tab>
				<v-tab
					:to="{
						name: 'academic-qualifications',
						query: { employeeId: $route.query.employeeId },
					}">
					{{ $T('tabs.academic') }}
				</v-tab>
				<v-tab
					:to="{
						name: 'practical-experiences',
						query: { employeeId: $route.query.employeeId },
					}">
					{{ $T('tabs.experience') }}
				</v-tab>
				<v-tab
					:to="{
						name: 'employee-attachments',
						query: { employeeId: $route.query.employeeId },
					}">
					{{ $T('tabs.attachments') }}
				</v-tab>
			</v-tabs>
			<div class="d-flex">
				<v-btn
					v-if="!editingEmployee && employeeId"
					class="me-1"
					small
					color="secondary"
					@click="editingEmployee = true">
					<v-icon left> $edit </v-icon>
					{{ $T('default-buttons.edit') }}
				</v-btn>
			</div>
		</div>
		<v-divider></v-divider>

		<router-view
			ref="child"
			:loading-fetch-employee="loadingFetchEmployee"
			:loading-adding-employee="loadingAddingEmployee"
			:employee-info="employee"
			:employee-id="employeeId"
			:editing-employee="Boolean(!editingEmployee && employeeId)"
			:disable-save="Boolean(personalValidation)"
			@add-employee="addEmployee"></router-view>
	</div>
</template>

<script>
import { contactsType } from '@/utils/enum';
const employeeValidationEnum = {
	wrongPhone: 1,
	wrongEmail: 2,
};

export default {
	name: 'EmployeeInfo',

	props: {
		employee: { type: Object, default: () => {} },
		employeeId: { type: String },
		loadingFetchEmployee: { type: Boolean },
	},

	data() {
		return {
			tabs: null,

			loadingAddingEmployee: false,

			editingEmployee: false,

			personalValidation: 0,

			employeeValidationEnum
		};
	},

	methods: {
		employeeValidate(employee) {
			const validations = [];

			if (employee.contactsInfo) {
				employee.contactsInfo.forEach((e) => {
					if (e.key === contactsType.email.value) {
						const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
						if (e.value && !emailPattern.test(e.value)) {
							validations.push(employeeValidationEnum.wrongEmail);
						}
					}
					if (e.key === contactsType.mobile.value) {
						const phonePattern = /^[0-9]{10}$/;
						if (e.value && !phonePattern.test(e.value)) {
							validations.push(employeeValidationEnum.wrongPhone);
						}
					}
				});
			}

			if (validations.length) {
				let error = '';
				if (validations.includes(employeeValidationEnum.wrongEmail)) error += 'يجب إدخال إيمايل صحيح';
				if (validations.includes(employeeValidationEnum.wrongPhone))
					error += 'الرقم الجوال يجب ان يكون من 10 ارقام،';

				this.$eventBus.$emit('show-snackbar', error, {
					error: true,
				});
				return false;
			}
			return true;
		},
		addEmployee(obj) {
			if (!this.employeeValidate({ ...this.employee, ...obj })) return;

			this.saveEmployeeInfo();
			if (this.personalValidation) return;

			this.loadingAddingEmployee = true;

			this.$store
				.dispatch('employee/addEmployee', {
					id: this.employeeId,
					...this.employee,
					...obj,
				})
				.then((res) => {
					this.$emit('fetch-employee', res.data);
					this.$router.replace(
						{ name: 'personal-info', query: { employeeId: res.data } },
						() => {},
					);
				})
				.catch((err) => {
					err.default && err.default();
				})
				.finally(() => {
					this.loadingAddingEmployee = false;
				});
		},
		saveEmployeeInfo() {
			if (this.$refs.child && this.$refs.child.getInfos) {
				const obj = this.$refs.child.getInfos();
				if (obj.validation?.for === 1) {
					this.personalValidation = obj.validation?.count;
				}
				this.$emit('change:employee', { ...this.employee, ...obj.data });
			}
		},
	},

	beforeRouteUpdate(to, from, next) {
		this.saveEmployeeInfo();
		next();
	},

	// todo:fancy add condition to ask before route if there is any changes
	// beforeRouteLeave(to, from, next) {
	// },

	mounted() {
		this.tabs = this.$route.fullPath;
	},
};
</script>

<style></style>
